/** Presentation-only derivations from Course Assessment list data.
 * No estimation of exam averages or students for missing/unknown counts.
 */
export const toSafeCount = value => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? Math.floor(n) : null;
};

export function assessmentProgress(enteredValue, totalValue) {
  const total = toSafeCount(totalValue);
  const entered = toSafeCount(enteredValue) ?? 0;
  const known = total !== null && total > 0;
  const recorded = known ? Math.min(entered, total) : entered;
  const missing = known ? Math.max(total - recorded, 0) : null;
  return {
    total, entered: recorded, known, missing,
    percent: known ? Number((recorded / total * 100).toFixed(1)) : null,
    complete: known && missing === 0,
  };
}

export const assessmentActionLabel = progress => {
  // Without a known student population, we cannot promise that there are
  // results to complete; opening the assessment is still useful.
  if (!progress.known) return 'Değerlendirmeyi aç';
  return progress.complete ? 'Sonuçları incele' : 'Sonuçları tamamla';
};

export const assessmentStatusLabel = progress => {
  if (!progress.known) return 'Öğrenci sayısı bekleniyor';
  if (progress.complete) return 'Tamamlandı';
  return `${progress.missing.toLocaleString('tr-TR')} sonuç bekliyor`;
};

export function summarizeAssessmentList(exams = []) {
  const items = (exams || []).map(exam => ({
    ...exam,
    progress: assessmentProgress(exam.completed_count, exam.student_count),
  }));
  const known = items.filter(exam => exam.progress.known);
  return {
    totalAssessments: items.length,
    completedAssessments: items.filter(exam => exam.progress.complete).length,
    pendingResults: known.reduce((n, exam) => n + exam.progress.missing, 0),
    knownAssessments: known.length,
    unknownAssessments: items.length - known.length,
  };
}
